import { render, staticRenderFns } from "./xingqingM.vue?vue&type=template&id=1289d45f&scoped=true"
import script from "./xingqingM.vue?vue&type=script&lang=js"
export * from "./xingqingM.vue?vue&type=script&lang=js"
import style0 from "./xingqingM.vue?vue&type=style&index=0&id=1289d45f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1289d45f",
  null
  
)

export default component.exports